import React from "react";
import Modal from 'react-bootstrap/Modal';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import _ from "underscore";

import PlantsService from "../services/plants.service";

// XLSX
import * as XLSX from 'xlsx/xlsx.mjs';

// import _ from 'underscore';

const PhenotypeTable = (props) => {
    // console.log("props: ", props);
    const handleClose = () => props.setShow(false);
    // const handleShow = () => props.setShow(true);

    let results = props.phenotypeResults;

    const column = results.length === 0 ? [] : Object.keys(results[0]) ;
    // console.log("column: ", column );

    // get table heading data
    let ThData = () => {
        return column.map((data) => {
            if( data !== "idPlant") {
                return <th key={data}>{data}</th>
            } else {
                return null;
            }
        })
    }

    // get table row data
    let tdData = () => {
        return results.map((data, index) => {
            return (
                <tr key={index}>
                    {
                        column.map((v, i) => {
                            if( v !== "idPlant") {
                                if( v === "PlantCode" ) {
                                    return <td key={i}> <p value={data[v]} style={{color: "#1a0dab", cursor: "pointer"}} onClick={ handleGetInfo }> {data[v]} </p> </td>
                                } else {
                                    return <td key={i}>{data[v]}</td>
                                }
                            } else {
                                return null;
                            }
                        })
                    }
                </tr>
            )
        })
    }

    function handleGetInfo( event ) {
        handleClose();
        props.setSpinner(true)
        console.log('clicked: ', event.target.innerText.trim() );
        var obj = {
            code: event.target.innerText.trim(),
            company: "Burchell"
        }
        console.log("obj: ", obj);
        PlantsService.getPlantSummary(obj).then(
            (response) => {
                console.log("plant response: ", response);

                var arr = [];
                _.each(Object.keys(response.result), function (value) {
                    if (typeof response.result[value] == "string") {
                        var obj = {
                            key: value,
                            data: response.result[value]
                        }
                        arr.push(obj);
                    }
                });
                // console.log("arr: ", arr);
                props.setPaternalCrosses( response.result.PaternalCrosses );
                props.setMaternalCrosses( response.result.MaternalCrosses );
                props.setPlantPhenotypes( response.result.Phenotypes );
                props.setPlantDescriptors( response.result.Descriptors );
                props.setPlantSummary(arr);
                props.setShowSummaryModal(true);
                props.setSpinner(false)
            },
            (error) => {
                console.log("error: ", error);
                props.setSpinner(false)
            }
        );
    }

    let goBack = () => {
        handleClose();
        setTimeout(function() {
            props.setShowModal( true );
        },500);
    }

    let downloadPhenotypes = () => {
        props.setSpinner(true)
        console.log("download phenos.");

        let results = props.phenotypeResults;

        /* generate a worksheet */
        var ws = XLSX.utils.json_to_sheet( results );

        /* add to workbook */
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet( wb, ws, "Verinomics");

        /* write workbook and force a download */
        XLSX.writeFile( wb, "PhenotypeResults.xlsx");
        // Loading
        setTimeout(function() {
            props.setSpinner(false)
        },500);
    }

    return (
        <>
            <Modal 
                show={props.show} 
                onHide={handleClose} 
                animation={true}
                size="lg"
                >
                <Modal.Header>
                    <Modal.Title> Phenotype Results</Modal.Title>
                    <CloseIcon className="float-right" style={{cursor: "pointer"}} onClick={handleClose} />
                </Modal.Header>
                <Modal.Body>
                    <div className="container" style={{overflow: "auto"}}>

                        <table className="table table-striped">
                            <thead>
                                <tr>{ThData()}</tr>
                            </thead>
                            <tbody>
                                {tdData()}
                            </tbody>
                        </table>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <Button className="pull-left mr-auto" variant="contained" onClick={goBack} >
                        <ArrowBackIcon />
                        Go Back
                    </Button>
                    <Button  variant="contained" onClick={ downloadPhenotypes } style={{ left: "0px"}} >
                        <DownloadIcon /> 
                        Download Phenotypes
                    </Button>
                    <Button variant="outlined" onClick={handleClose} style={{ marginLeft: "5px"}}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default PhenotypeTable;
